import { render, staticRenderFns } from "./StaffPageDetailsModal.vue?vue&type=template&id=57719036&scoped=true&"
import script from "./StaffPageDetailsModal.vue?vue&type=script&lang=js&"
export * from "./StaffPageDetailsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57719036",
  null
  
)

export default component.exports